export class DbOutOfDateError extends Error {
  constructor(
    text: string
  ) {
    super(text)
  }
}
